import { objectSpread2 as _objectSpread2 } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { format } from './utils/fecha.js';

var script = {
  name: 'CalendarDay',
  inject: ['state'],
  props: {
    day: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      isHovering: false,
      isFocused: false
    };
  },
  computed: {
    ariaLabel() {
      const formattedDate = format(this.day.date, 'WWWW, MMMM D, YYYY', this.state.locale);
      return this.isSelected ? `${formattedDate}. Selected date.` : `${formattedDate}. Select this date.`;
    },
    isDragging() {
      return !!this.state.dragValue;
    },
    isOutsideMonth() {
      return !this.day.inMonth;
    },
    isDisabled() {
      return !!this.day.disabled;
    },
    isSelected() {
      if (!this.day.attribute) {
        return false;
      }
      if (this.day.attribute.key === 'select' && this.day.attribute.targetDate.isDate) {
        return this.day.attribute.targetDate.dateTime === this.day.dateTime;
      }
      if (this.onStart || this.onEnd) {
        return !this.state.dragValue;
      }
      return false;
    },
    onStart() {
      if (!this.day.attribute) {
        return false;
      }
      return this.day.attribute.targetDate.startTime === this.day.dateTime;
    },
    onEnd() {
      if (!this.day.attribute) {
        return false;
      }
      return this.day.attribute.targetDate.endTime === this.day.dateTime;
    },
    onStartAndEnd() {
      return this.onStart && this.onEnd;
    },
    dayEvent() {
      return _objectSpread2(_objectSpread2({}, this.day), {}, {
        el: this.$refs.content
      });
    },
    inRange() {
      if (!this.day.attribute) {
        return false;
      }
      if (!['select', 'drag'].includes(this.day.attribute.key)) {
        return false;
      }
      return !this.isDisabled && !this.isDateOrComplex && !this.onStartAndEnd;
    },
    isDateOrComplex() {
      if (!this.day.attribute) {
        return false;
      }
      const {
        isDate,
        isComplex
      } = this.day.attribute.targetDate;
      return isDate || isComplex;
    },
    isDragStart() {
      if (this.state.type !== 'range' || !this.state.dragValue || !this.day.attribute) {
        return false;
      }
      return this.state.dragValue.start.getTime() === this.day.dateTime;
    }
  },
  methods: {
    getDayEvent(origEvent) {
      return _objectSpread2(_objectSpread2({}, this.dayEvent), {}, {
        event: origEvent
      });
    },
    handleDayClick($event) {
      if (this.isDisabled) {
        return;
      }
      this.$emit('dayclick', this.getDayEvent($event));
    },
    handleDayMouseEnter($event) {
      if (this.isDisabled) {
        return;
      }
      this.isHovering = true;
      this.$emit('daymouseenter', this.getDayEvent($event));
    },
    handleDayMouseLeave($event) {
      this.isHovering = false;
      this.$emit('daymouseleave', this.getDayEvent($event));
    },
    handleDayFocus($event) {
      this.isFocused = true;
      this.$emit('dayfocusin', this.getDayEvent($event));
    },
    handleDayBlur($event) {
      this.isFocused = false;
      this.$emit('dayfocusout', this.getDayEvent($event));
    }
  }
};

export { script as default };
//# sourceMappingURL=calendar-day.vue2.js.map
